import { render, staticRenderFns } from "./StudentSidebar.vue?vue&type=template&id=a9640688&scoped=true&lang=pug&"
import script from "./StudentSidebar.vue?vue&type=script&lang=ts&"
export * from "./StudentSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./StudentSidebar.vue?vue&type=style&index=0&id=a9640688&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9640688",
  null
  
)

export default component.exports